/* eslint-disable import/no-default-export */
import {SideCartController} from './SideCartController';
import {ControllerParams} from '@wix/yoshi-flow-editor';
import {IWidgetController} from '@wix/native-components-infra/dist/src/types/types';

export const controller = (controllerParams: ControllerParams): IWidgetController => {
  const siteStore = controllerParams?.appData?.context.siteStore;
  let controllerClass: SideCartController | undefined;

  return {
    async pageReady() {
      try {
        await siteStore.loadClientConfig();
        controllerClass = new SideCartController(controllerParams);

        await controllerClass.init();
        controllerParams.controllerConfig.wixCodeApi.location.onChange(() => void controllerClass.load());
      } catch (error) {
        console.error(error);
        controllerParams.controllerConfig.setProps({generalError: true});
        controllerParams.appData.reportError(error);
      }
    },
    updateConfig: (_$w, updatedConfig: {[key: string]: any}): void => {
      return void controllerClass.onStyleUpdate?.(updatedConfig.style.styleParams);
    },
  };
};

export default controller;
